import "./ShipmentCardDashboardDestination.scss";
import ShipmentCardDashboardBase from "../shipment-card-dashboard-base/ShipmentCardDashboardBase";
import { IShipmentCard } from "../../../../../models";

const ShipmentCardDashboardDestination = ({ className, ...rest }: IShipmentCard) => (
    <ShipmentCardDashboardBase className={`ShipmentCardDashboardDestination ${className || ""}`} {...rest} />
);

export default ShipmentCardDashboardDestination;
